import { api } from '@api';
import type { CommentData, CommentsAdapter } from '@features/Comments/types';

export const recordingCommentsAdapter: CommentsAdapter = {
  // This tells TanStack Query how to cache these specific comments
  queryKey: 'recording_comments',

  getComments: async (entityId: string): Promise<CommentData[]> => {
    const { data, error } = await api()
      .from('recording_comments')
      .select(`
        id,
        content,
        parent_id,
        created_at,
        profile_id,
        profile:profile_id (
          id,
          username,
          profile_private (role)
        )
      `)
      .eq('recording_id', entityId)
      .order('created_at', { ascending: false }); // Ensures oldest (or newest) replies are ordered

    if (error) throw new Error(error.message);

    // The normalized DB matches the CommentData interface perfectly!
    return data as unknown as CommentData[];
  },

  createComment: async ({ entityId, content, profileId, parentId }) => {
    const { data, error } = await api()
      .from('recording_comments')
      .insert({
        recording_id: entityId, // Map generic entityId -> recording_id
        content,
        profile_id: profileId,
        parent_id: parentId || null,
      })
      .select()
      .single();

    if (error) throw new Error(error.message);
    return data;
  },

  updateComment: async (commentId: string, content: string) => {
    const { error } = await api()
      .from('recording_comments')
      .update({ content })
      .eq('id', commentId);

    if (error) throw new Error(error.message);
  },

  deleteComment: async (commentId: string) => {
    const { error } = await api()
      .from('recording_comments')
      .delete()
      .eq('id', commentId);

    if (error) throw new Error(error.message);
  }
};
